<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Configurtion Level</mat-label>
      <mat-select [formControl]="schemaKindControl">
        <mat-option value=""> - </mat-option>
        <mat-option value="COUNTRY_SCHEMA"> Country </mat-option>
        <mat-option value="WEEE_SYSTEM_SCHEMA"> WEEE-System </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.start' | translate}} {{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="number" [formControl]="startYearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.end' | translate}} {{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="number" [formControl]="endYearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.entry' | translate}}</mat-label>
      <input matInput type="text" [formControl]="entryControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'kf-reporting.UNU-key-set' |translate}}</mat-label>
      <input matInput type="text" [formControl]="unuKeyControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'kf-reporting.key-figure-category-set' |translate}}</mat-label>
      <input matInput type="text" [formControl]="kfCategoryControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'kf-reporting.collection-stream-set' |translate}}</mat-label>
      <input matInput type="text" [formControl]="collectionStreamControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Is open</mat-label>
      <mat-select [formControl]="openControl">
        <mat-option value=""> - </mat-option>
        <mat-option value="true"> Yes </mat-option>
        <mat-option value="false"> No </mat-option>
      </mat-select>
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>

  </form>
</div>

